module.exports = __webpack_public_path__ + "static/media/71AOiTcCc4L._SL1500_.298a8672.jpg";